export default {
  1: '中文',
  // 2: '日语',
  // 3: '韩语',
  4: '英语'
  // 5: '俄语',
};
